import { css } from 'styled-components';
import token from 'styled-token';
import { StyledComboboxAdditional } from '../../components/ComboboxAdditional/ComboboxAdditional.styles';
import { StyledIcon } from '../../components/Icon/Icon.styles';
import { StyledInput } from '../../components/Input/Input.styles';
import { StyledListbox } from '../../components/Listbox/Listbox.styles';
import { StyledTag } from '../../components/Tag/Tag.styles';
import { StyledTagCloseButton } from '../../components/TagCloseButton/TagCloseButton.styles';
import { sizeMixin } from '../sizeMixin';
import { spaceMixin } from '../spaceMixin';
import { InputMixin } from './InputMixin';
import { SelectMixin } from './SelectMixin';
var errorCSS = function errorCSS(props) {
  if (!props.error) {
    return '';
  }
  return token({
    borderColor: 'Input.borderColorError'
  }, function (tokens) {
    return css(["&&,&&:hover,&&:active,&&:focus-within{border-color:", ";}"], tokens.borderColor);
  })(props);
};
var focusCSS = function focusCSS(props) {
  if (props.disabled) {
    return '';
  }
  return token({
    focusShadow: 'ComboboxInput.boxShadow.focus',
    backgroundColor: 'Input.backgroundColorInteractive'
  }, function (_ref) {
    var focusShadow = _ref.focusShadow,
      backgroundColor = _ref.backgroundColor;
    return css(["&:focus-within{box-shadow:", ";}&:focus-within,&:focus-within ", ",&:active ", "{background-color:", ";}"], focusShadow, StyledInput, StyledInput, backgroundColor);
  })(props);
};
var disabledCSS = function disabledCSS(props) {
  if (!props.disabled) {
    return '';
  }
  return token({
    opacity: 'ComboboxInput.TagCloseButton.opacity.disabled',
    cursor: 'ComboboxInput.TagCloseButton.cursor.disabled'
  }, function (_ref2) {
    var _ref2$opacity = _ref2.opacity,
      opacity = _ref2$opacity === void 0 ? 1 : _ref2$opacity,
      _ref2$cursor = _ref2.cursor,
      cursor = _ref2$cursor === void 0 ? 'default' : _ref2$cursor;
    return css(["", "{opacity:", ";cursor:", ";}"], StyledTagCloseButton, opacity, cursor);
  })(props);
};
var paddingRightCSS = function paddingRightCSS(props) {
  var appearance = props.appearance,
    isClearable = props.isClearable;
  return token({
    chevronWidth: 'Select.chevronWidth',
    horizontalSpacing: 'Input.horizontalSpacing',
    closeButtonSize: 'Tag.closeButtonSize',
    closeButtonMargin: 'Tag.targetPadding',
    basePaddingSize: 'ComboboxInput.select.basePaddingSize'
  }, function (tokens) {
    /**
     * Padding for appearance of "select" vs. "input"
     * Adds extra padding for the chevron
     * @see SelectMixin.js
     */
    var basePadding = appearance === 'select' ? spaceMixin(tokens.basePaddingSize, function (space) {
      return space.value + tokens.chevronWidth;
    })(props) : tokens.horizontalSpacing;

    // Adds extra padding to cover the clear button
    var clearablePadding = isClearable ? tokens.closeButtonSize + tokens.closeButtonMargin : 0;
    return css(["padding-right:", "px;"], basePadding + clearablePadding);
  })(props);
};
export var ComboboxInputMixin = function ComboboxInputMixin(props) {
  var appearance = props.appearance,
    disabled = props.disabled,
    expanded = props.expanded,
    size = props.size;
  var isSelect = appearance === 'select';
  return token({
    borderWidth: 'Input.borderWidth',
    chevronWidth: 'Select.chevronWidth',
    fontType: 'Input.fontType',
    tagMargin: 'ComboboxInput.tagMargin',
    tagPadding: 'Tag.verticalPadding',
    closeButtonSize: 'Tag.closeButtonSize',
    closeButtonMargin: 'Tag.targetPadding',
    horizontalSpacing: 'Input.horizontalSpacing',
    minInputWidth: 'ComboboxInput.minInputWidth',
    listboxBorder: 'ComboboxInput.ListboxBorder.border',
    inputBorder: 'ComboboxInput.Input.border',
    inputPadding: 'ComboboxInput.Input.padding',
    inputShadow: 'ComboboxInput.Input.boxShadow'
  }, function (_ref3) {
    var borderWidth = _ref3.borderWidth,
      chevronWidth = _ref3.chevronWidth,
      fontType = _ref3.fontType,
      tagMargin = _ref3.tagMargin,
      tagPadding = _ref3.tagPadding,
      closeButtonSize = _ref3.closeButtonSize,
      horizontalSpacing = _ref3.horizontalSpacing,
      minInputWidth = _ref3.minInputWidth,
      listboxBorder = _ref3.listboxBorder,
      _ref3$inputBorder = _ref3.inputBorder,
      inputBorder = _ref3$inputBorder === void 0 ? 0 : _ref3$inputBorder,
      _ref3$inputPadding = _ref3.inputPadding,
      inputPadding = _ref3$inputPadding === void 0 ? 0 : _ref3$inputPadding,
      _ref3$inputShadow = _ref3.inputShadow,
      inputShadow = _ref3$inputShadow === void 0 ? 'none' : _ref3$inputShadow;
    return css(["", " ", " ", " ", " ", " position:relative;display:flex;flex-wrap:wrap;align-items:center;&&{cursor:", ";}", " ", "{border:", ";padding:", ";box-shadow:", ";flex:1 0 ", ";padding-top:", "px;padding-bottom:", "px;opacity:1;}> ", "{position:absolute;right:", "px;top:calc(50% - ", "px);", "{box-shadow:none;}}", "{margin-right:", "px;margin-top:", "px;margin-bottom:", "px;cursor:default;&:last-of-type{margin-right:", "px;}}", " + ", "{margin-left:-", "px;margin-right:", "px;}", "{border:", ";}"], isSelect ? SelectMixin(Object.assign({}, props, {
      'aria-expanded': "" + expanded
    })) : InputMixin(props), paddingRightCSS(props), focusCSS(props), errorCSS(props), disabledCSS(props), disabled ? 'default' : 'text', sizeMixin({
      fontType: fontType,
      borderWidth: borderWidth * 2 + tagMargin + tagPadding * 2,
      size: size
    })(props), StyledInput, inputBorder, inputPadding, inputShadow, minInputWidth, tagMargin / 2 + tagPadding, tagMargin / 2 + tagPadding, StyledTagCloseButton, isSelect ? chevronWidth : horizontalSpacing, closeButtonSize / 2, StyledIcon, StyledTag, tagMargin, tagMargin / 2, tagMargin / 2, horizontalSpacing, StyledTag, StyledComboboxAdditional, horizontalSpacing - tagMargin, horizontalSpacing, StyledListbox, listboxBorder);
  })(props);
};